module.exports = __webpack_public_path__ + "assets/img/201.bb6ccc65.png";